import type { EndpointDef } from '@skynet/data-helpers';

/**
 * Central endpoint definitions — single source of truth for the DEX cold
 * wallets API.
 *
 * This file drives:
 * - Enhanced API: computed endpoint keys in `enhanceEndpoints`
 * - Hook re-exports: clean name → generated name mapping
 * - MSW mock factories: HTTP method + URL path pattern
 */
export const DEX_COLD_WALLETS_API_ENDPOINTS = {
  listColdWallets: {
    generated: 'apiControllerGetColdWallets',
    method: 'get',
    path: '/loan/cold-wallets/list/:projectId',
  },
  formatAddress: {
    generated: 'apiControllerFormatAddress',
    method: 'get',
    path: '/loan/format/:address',
  },
  listColdWalletSnapshots: {
    generated: 'apiControllerGetSnapshots',
    method: 'get',
    path: '/loan/cold-wallets/snapshots/wallet/:walletId',
  },
  listProjectSnapshots: {
    generated: 'apiControllerGetSnapshotsByProject',
    method: 'get',
    path: '/loan/cold-wallets/snapshots/project/:projectId',
  },
  linkColdWallet: {
    generated: 'apiControllerLinkColdWallet',
    method: 'post',
    path: '/loan/cold-wallets/link',
  },
  unlinkColdWallet: {
    generated: 'apiControllerUnlinkColdWallet',
    method: 'post',
    path: '/loan/cold-wallets/unlink',
  },
  updateColdWallet: {
    generated: 'apiControllerUpdateColdWallet',
    method: 'put',
    path: '/loan/cold-wallets/update/:walletId',
  },
  createColdWalletSnapshot: {
    generated: 'apiControllerAddSnapshot',
    method: 'post',
    path: '/loan/cold-wallets/snapshots/add',
  },
} as const satisfies Record<string, EndpointDef>;

export type DexColdWalletsEndpointName = keyof typeof DEX_COLD_WALLETS_API_ENDPOINTS;
